
export class CleanBatchWrapper {
retentionDays: number | null;
status: string;
}

